import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiStep: {
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({
            '& .MuiSvgIcon-root': {
              fontSize: 24,
            },
            '& .MuiStepIcon-text': {
              fill: 'white',
              fontSize: theme.typography.htmlFontSize,
            },
            '& .Mui-disabled .MuiStepIcon-root': {
              color: theme.palette.grey[500],
            },
          }),
      },
    },
  },
});

export default theme.components;
